import { styled, ToggleGroup } from "tamagui";

export const ToggleGroupItem = styled(ToggleGroup.Item, {
  backgroundColor: "transparent",
  padding: "$medium",
  color: "$color",

  variants: {
    active: {
      true: {
        backgroundColor: "$pressablePrimaryBackground",
        color: "$pressablePrimaryLabel",

        hoverStyle: {
          backgroundColor: "$pressablePrimaryBackground",
          // @ts-expect-error Tamagui sucks
          color: "$pressablePrimaryLabel",
        },

        focusStyle: {
          backgroundColor: "$pressablePrimaryBackground",
          // @ts-expect-error Tamagui sucks
          color: "$pressablePrimaryLabel",
        },
      },
    },
  },
});
